import { Injectable } from '@angular/core';
import { NgRedux, select } from '@angular-redux/store';
import { IAppState, Actions, ChildRecipeEntity, IngredientsEntity, CustomizationGroupsEntity, NonExistentModifiers, NonExistentSpecialInstructions, isModifierGroupDefaultSelected } from '@core/redux/stores';
import { Observable, Subscription, BehaviorSubject, combineLatest } from 'rxjs';
import { Router } from '@angular/router';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import * as Store from '@core/redux/stores';
import { MenuUtilityService } from '@core/services/menu-utlities.services';
import { LocationsEntity } from '@core/redux/stores';
import * as _ from 'lodash-es';
import { CustomizationService } from '@features/customization/services';
import { ProxyService } from '@core/services/proxy.service';
import { AlertService } from '@core/services/alert.service';
import { RewardItemService } from '@core/services/reward-item.service';
import { LoggingService } from '@core/services/logging.service';
import { OfferService } from '@core/services/offer.service';
import { ErrorCodesService } from './error-codes.service';
import { ConfirmModalService } from './confirm-modal.service';
import { OrderDetails } from '@features/ordering/models/order-details.model';
import { TaxCalculatorService } from '@ordering/services/tax-calculator.service';
import { CustomizationSubgroupService } from './customization-subgroup.service';
import { MealInfo } from '@app/features/ordering/models/start-new-order-meal-info.model';
import { Constants } from '@core/constants/core.constants';
import { AddFavoriteNameService } from './add-favorite-name.service';
import * as gtmExternal from '@app/shared/models/configs/gtm.external';
import { GtmService, UtilitiesService } from '.';
import { MessageSummaryLoyalty } from '@app/features/account/messaging/models';
import { RewardService } from '@app/features/rewards/services/reward.service';
import { RecipeMap, RecipeType } from '@app/features/customization/models';
import { Offer } from '@features/account/models/offer.model';
import { map } from 'rxjs/operators';
@Injectable()
export class GetOrderService {

  private subscriptions = new Subscription();
  private orderdCollection: Store.Order = new Store.Order;
  public subTotal: number;
  private childReceipeData: any;
  private childRecipe: Store.ChildRecipeEntity;
  private isFavorite: boolean;
  private favName: string;
  public order: Store.UserOrderInfo;
  private recipeIds: string;
  private unavailableRecipes: Store.UnavailableRecipes[] = [];
  private unavailableModifierGroups: Store.UnavailableModifierGroups[] = [];
  private modifierGroupIds: string;
  private getActiveReward: any;
  private getOfferRecipes: any;
  private currentRewardsCount: number;
  public offerCouponCode: number;
  public mealOrder: any;
  public confirmText: string;
  public tax: number;
  public isTaxIncluded: boolean;
  public orderDetails: OrderDetails;
  @select(appState => appState.submittedOrder) submittedOrder: Observable<Store.UserOrderInfo>;
  @select((appState) => appState.locationSelected) locationSelected: Observable<Store.LocationsEntity>;
  @select((appState) => appState.activeOrder) activeOrder: Observable<Store.Order>;

  private deliveryAddressloadedSubject = new BehaviorSubject<boolean>(false);
  public isDeliveryAddressLoaded$ = this.deliveryAddressloadedSubject.asObservable();

  private location: LocationsEntity;
  ingredientList: any[];
  orderTotal: number;
  private nonExistentModifiers: NonExistentModifiers[];
  private nonExistentSpecialInstructions: NonExistentSpecialInstructions[];
  constructor(
    private proxy: ProxyService,
    private ngRedux: NgRedux<IAppState>,
    private menuUtil: MenuUtilityService,
    private alertService: AlertService,
    private confirmModalService: ConfirmModalService,
    private router: Router,
    private customizationService: CustomizationService,
    private rewardItemService: RewardItemService,
    private logger: LoggingService,
    private offerService: OfferService,
    private customizationSubgroupService: CustomizationSubgroupService,
    private taxCalulcator: TaxCalculatorService,
    private addFavoriteNameService: AddFavoriteNameService,
    private gtmService: GtmService,
    private rewards: RewardService) {
    this.confirmText = 'OK, Got It';
    this.subscriptions.add(
      this.confirmModalService.btnEvent.subscribe(
        (data: string) => {
          if (data === this.confirmText) {
            this.router.navigateByUrl('/home');
          }
          if (data === 'redirectToMenu') {
            if (this.location && this.location.unit) {
              this.router.navigate(['/locations/' + this.location.unit + '/menu'], { queryParams: UtilitiesService.generateQueryParams([Constants.SHOW_CART], ['false'])});
            } else {
              this.router.navigate(['/menu'], { queryParams: UtilitiesService.generateQueryParams([Constants.SHOW_CART], ['false']) });
            }
          }
        }
      )
    );
    this.subscriptions.add(
      this.locationSelected.subscribe(
        (loc) => {
          this.location = <LocationsEntity>loc;
        }
      )
    );
    this.submittedOrder.subscribe(succ => {
      this.order = succ as Store.UserOrderInfo;
    });
    this.initializeTotalAndTax();
  }

  private initializeTotalAndTax() {
    this.orderTotal = 0;
    this.subTotal = 0;
    this.tax = 0;
  }

  async getRewardCount() {
    this.rewards.getRewardSummary().then(
      (success) => {

        const response = <MessageSummaryLoyalty>success;

        // Scenario to handle if service doesn't return current rewards and visits count
        if (response) {
          this.currentRewardsCount = (response.currentRewards !== undefined) ? response.currentRewards : 0;
        }

      });
  }

  async getFavoriteOrder(id: number, favFromMenu: boolean) {
    sessionStorage.setItem('gtmOrderType','favorites');
    this.rewards.getRewardSummary().then(
      (success) => {

        const response = <MessageSummaryLoyalty>success;

        // Scenario to handle if service doesn't return current rewards and visits count
        if (response) {
          this.currentRewardsCount = (response.currentRewards !== undefined) ? response.currentRewards : 0;
          this.subscriptions.add(this.activeOrder.subscribe(
            (Succ) => {
              if (Succ && Succ.childRecipes && Succ.childRecipes.length > 0) {
                this.orderdCollection = _.cloneDeep(Succ as Store.Order);
                if (!this.orderdCollection.childRecipes.find(child => child.isOfferAdded === true || !child.offerCouponCode)) {
                  if (!this.orderdCollection.childRecipes.find(child => child.useReward === true)) {
                    this.getActiveReward = [];
                    this.rewardItemService.updateCurrentRewardItem(undefined);
                  } else if (this.orderdCollection.childRecipes.find(child => child.useReward === true)) {
                    this.childRecipe = this.orderdCollection.childRecipes.find(child => child.useReward === true);
                    this.rewardItemService.updateCurrentRewardItem(this.childRecipe);
                  }
                }
              } else {
                this.orderdCollection = _.cloneDeep(Succ as Store.Order);
                if (this.orderdCollection) {
                  this.orderdCollection.childRecipes = [];
                }
                this.getActiveReward = [];
              }
            },
            (Err) => {
              this.alertService.error(Err.error.message);
            }));
          this.proxy.httpGet(ApiRoutes.GET_FAVORITES_ID + '/' + id).toPromise().then(
            (success1) => {
              const successResp = <Store.Meal>success1.body.valueOf();
              const meal = successResp;
              this.isFavorite = successResp.isFavorite;
              this.favName = successResp.favoriteName;
              const locationsEntity = meal.location as Store.LocationsEntity;
              if (locationsEntity.capabilities.indexOf('Mobile-Order') === -1) {
                this.onlineOrderingNotAvailable();
                return;
              }
              const FavoritedLocationId = <any>locationsEntity.id;
              sessionStorage.setItem('FavoritedLocationId', FavoritedLocationId);
              if (this.orderdCollection.childRecipes) {
                if (this.orderdCollection.childRecipes.length > 0) {
                  this.isFavorite = false;
                }
              }

              this.childReceipeData = {};
              this.childReceipeData.childrec = [];
              this.childReceipeData.id = [];
              // GTM Select Item - favorites
              sessionStorage.setItem('select_items_gtm', 'favorites');
              meal.recipes.forEach(
                (childrec) => {
                  this.childReceipeData.id.push(childrec.recipeId);
                  this.childReceipeData.childrec.push(childrec);
                  if (this.orderdCollection && this.orderdCollection.childRecipes &&
                    !this.orderdCollection.childRecipes.find(child => child.isOfferAdded === true || !child.offerCouponCode)) {
                    if (childrec.useReward) {
                      if (this.getActiveReward === undefined) {
                        this.getActiveReward = [];
                      }
                      this.getActiveReward.push(childrec.recipeId);
                    }
                  }
                }
              );
              this.getDefaultMenuChildRecipeToCustomize(meal.locationId);
            }
          );
        }

      },
      (err) => {
        this.alertService.error(err.error.message);
      });

  }
  async getLatestOrder() {
    return await this.subscriptions.add(this.activeOrder.subscribe(
      (Succ) => {
        if (Succ && Succ.childRecipes && Succ.childRecipes.length > 0 || Succ?.pickupPath) {
          this.orderdCollection = _.cloneDeep(Succ as Store.Order);
        } else {
          this.clearGetOrderServiceData();
        }
      }
    ));
  }

  async getOrder(id: number) {
    this.clearGetOrderServiceData();
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection});
    return await this.proxy.httpGet(ApiRoutes.GET_ORDER_BY_ID + id).toPromise().then(
      (success) => {
        const successResp = <Store.Meal>success.body.valueOf();
        const meal = successResp;
        // GTM Select Item - Order
        sessionStorage.setItem('select_items_gtm', 'order');
        const locationsEntity = meal.location as Store.LocationsEntity;
        const FavoritedLocationId = <any>locationsEntity.id;
        sessionStorage.setItem('FavoritedLocationId', FavoritedLocationId);
        if (successResp.favoriteName !== '') {
          this.isFavorite = true;
          this.favName = successResp.favoriteName;
        }
        if (successResp.isFavorite === undefined || successResp.isFavorite === false) {
          this.isFavorite = false;
          this.favName = '';
        }
        this.getOrderInfo(<Store.Meal>success.body.valueOf());
      }
    );
  }

  async getOrderAndAppend(id: any, automaticDeliveryLocation = null) {
    if(!automaticDeliveryLocation || automaticDeliveryLocation !== 'true') {
      this.resetReorderField();
    }
    await this.getLatestOrder();
    try {
      if(id.toString().toLowerCase() === Constants.RECENT_ORDER) {
         await this.reOrderLastOrder();
      }
    } catch (error) {
      this.router.navigate(['/locations/' + this.location.unit + '/menu']);
    }

    return await this.proxy.httpGet(ApiRoutes.GET_ORDER_BY_ID + id).toPromise().then(
      (success) => {
        this.reorderForSignedInUser(success);        
      }
    );
  }

  private reorderForSignedInUser(meal) {
    // GTM Select Item - Re Order
    sessionStorage.setItem('select_items_gtm', 'reorder');
    const reorderedItems = <Store.Meal>meal.body.valueOf();
    const locationsEntity = reorderedItems.location as Store.LocationsEntity;
        if (locationsEntity.capabilities.indexOf('Mobile-Order') === -1) {
          this.onlineOrderingNotAvailable();
          return;
        }
        if (this.orderdCollection && this.orderdCollection.childRecipes
          && this.orderdCollection.childRecipes.length > 0) {
          this.clearFavoriteSessionStorage();
          const doesOfferExistInCart = this.doesOfferExistInCart(this.orderdCollection);
          const doesRewardExistInCart = this.doesRewardExistInCart(this.orderdCollection);
          const doesReorderHaveOffer = this.doesReorderHaveOffer(reorderedItems);
          const doesReorderHaveReward = this.doesReorderHaveReward(reorderedItems);
          if ((doesOfferExistInCart || doesRewardExistInCart)
            && (doesReorderHaveOffer || doesReorderHaveReward)) {
            // Convert into regular item
            this.convertIntoRegularItems(reorderedItems);
          }
        } else {
          if (reorderedItems.favoriteName && reorderedItems.favoriteName !== '') {
            this.isFavorite = true;
            this.favName = reorderedItems.favoriteName;
            this.orderdCollection.isFavorite = true;
            if (reorderedItems?.mealId) {
              this.addFavoriteNameService.setFavId(reorderedItems.mealId);
            }
            sessionStorage.setItem('FavoritedLocationId', <any>locationsEntity.id);
          }
        }
        // append to the cart - remove any offers
        reorderedItems.recipes?.forEach(r => r.offerId = null);
        this.getOrderInfo(reorderedItems);
  }

  private async reOrderLastOrder() {
    if (this?.order?.orderNumber) {
      return await this.proxy.httpGet(ApiRoutes.GET_ORDER_BY_ID + this.order.orderNumber).toPromise().then(
        (success) => {
          this.reorderForSignedInUser(success);        
        }
      );
    } else {
      await this.reOrderLastAvailableOrder();
    }
  }

  private async reOrderLastAvailableOrder() {
    try {      
      const  success = await this.proxy.httpGet(ApiRoutes.GET_MOST_RECENT_AVAILABLE).toPromise();      
      if (success && success?.body) {
        this.reorderForSignedInUser(success);
      } else {
        this.router.navigate(['/locations/' + this.location.unit + '/menu']);
      }      
    } catch (error) {
      this.router.navigate(['/locations/' + this.location.unit + '/menu']);
    }

  }

  clearFavoriteSessionStorage(): void {
    sessionStorage.removeItem('FavoritedLocationId');
    sessionStorage.removeItem('favOrderId');
    sessionStorage.removeItem('favoriteName');
  }

  convertIntoRegularItems(reorderedItems: Store.Meal) {
    if (reorderedItems && reorderedItems.recipes) {
      reorderedItems.recipes.forEach(
        (recipe) => {
          recipe.useReward = false;
          recipe.offerId = null;
          recipe.isOfferAdded = false;
        }
      );
    }
  }

  doesReorderHaveReward(reorderedItems: Store.Meal): boolean {
    if (reorderedItems && reorderedItems.recipes) {
      return (reorderedItems.recipes.find(child => child.useReward === true)) ? true : false;
    }
    return false;
  }

  doesReorderHaveOffer(reorderedItems: Store.Meal): boolean {
    if (reorderedItems) {
      return (reorderedItems.recipes.find(child => child.isOfferAdded === true)) ? true : false;
    }
    return false;
  }

  doesOfferExistInCart(itemsInTheCart: Store.Order): boolean {
    if (itemsInTheCart && itemsInTheCart.childRecipes) {
      return (itemsInTheCart.childRecipes.find(recipe => recipe.offerCouponCode
        && recipe.offerCouponCode !== 0)) ? true : false;
    }
    return false;
  }

  doesRewardExistInCart(itemsInTheCart: Store.Order): boolean {
    if (itemsInTheCart && itemsInTheCart.childRecipes) {
      return (itemsInTheCart.childRecipes.find(child => child.useReward === true)) ? true : false;
    }
    return false;
  }

  private clearGetOrderServiceData(): void {
    this.isFavorite = false;
    this.favName = undefined;
    this.orderdCollection = new Store.Order();
    this.getActiveReward = [];
    this.getOfferRecipes = [];
    this.offerService.clearOffers(true);
  }

  private resetReorderField(): void {
    this.isFavorite = false;
    this.favName = undefined;
    this.getActiveReward = [];
    this.getOfferRecipes = [];
  }

  async getOrderLocation(id: number, type: string, search: boolean = true) {
    if (type === 'order') {
      try {
        if (id.toString().toLowerCase() === Constants.RECENT_ORDER) {
          await this.reOrderLastOrder();
        }
      } catch (error) {
        this.router.navigate(['/menu']);
      }
      this.proxy.httpGet(ApiRoutes.GET_ORDER_BY_ID + id).toPromise().then(
        (success) => {
          const meal = <Store.Meal>success.body.valueOf();
          if (search) {
            const locationsEntity = meal.location as Store.LocationsEntity;
            this.router.navigate(['/locations/menu'], { queryParams: 
              UtilitiesService.generateQueryParams([Constants.RETURN_URL, Constants.SEARCH], [`/menu?${Constants.ORDER_ID}=` + id, locationsEntity.unit])});
          } else {
            this.router.navigate(['/locations/menu'], { queryParams: 
              UtilitiesService.generateQueryParams([Constants.RETURN_URL],[`/menu?${Constants.ORDER_ID}=` + id])});
          }
        }, error => {
          // Couldnt get the order - nothing more to do, go home
          this.router.navigate(['/home']);
        }
      );
    } else if (type === 'favorite') {
      this.proxy.httpGet(ApiRoutes.GET_FAVORITES_ID + '/' + id).toPromise().then(
        (success) => {
          const meal = <Store.Meal>success.body.valueOf();
          const locationsEntity = meal.location as Store.LocationsEntity;
          // No longer need to filter favorites by location
          this.router.navigate(['/locations/menu'], { queryParams: 
            UtilitiesService.generateQueryParams([Constants.RETURN_URL], [`/menu?${Constants.FAVORITE_ID}=` + id])});
        }
      );
    }
  }

  async getOrderForGuest(id: any, orderStatusMsg: string, guestId: string) {
    await this.getLatestOrder();
    if(id && guestId && id!== Constants.RECENT_ORDER) {
      return await this.getGuestOrderById(id, guestId, null);
    }
    if (this.order !== undefined && this.order !== null && this.order) {
      if (this.order.guid) {
        if ((orderStatusMsg && orderStatusMsg !== null &&
          !(orderStatusMsg === Constants.CANCELLED_BY_SYSTEM || orderStatusMsg === Constants.LOCATION_CLOSED)) && this.location) {
          this.router.navigateByUrl('/locations/' + this.location.unit + '/menu');
        } else {
          return await this.getGuestOrderById(this.order.orderNumber, this.order.guid, orderStatusMsg);
        }
      }
    }
  }

  private async getGuestOrderById(orderNumber: any, guestId: string, orderStatusMsg: string) {
    return await this.proxy.httpGet('/meals/orders/' + orderNumber + '/guestuser/' + guestId).toPromise().then(
      (success) => {
        const location = (<Store.Meal>success.body.valueOf()).location;
        if ((orderStatusMsg && orderStatusMsg !== null &&
          !(orderStatusMsg === Constants.CANCELLED_BY_SYSTEM || orderStatusMsg === Constants.LOCATION_CLOSED))) {
          const loc = location.unit;
          this.router.navigateByUrl('/locations/' + loc + '/menu');
        } else {
          if (this.location && location && location.capabilities.indexOf('Mobile-Order') === -1 && location.id === this.location.id) {
            this.onlineOrderingNotAvailable();
            return;
          }
          const meal = <Store.Meal>success.body.valueOf();
          // GTM Select Item - Guest Order
          sessionStorage.setItem('select_items_gtm', 'guestorder');
          this.getOrderInfo(meal);
        }
      }
    );
  }

  getOrderInfo(meal: Store.Meal) {
    this.childReceipeData = {};
    this.childReceipeData.childrec = [];
    this.childReceipeData.id = [];
    this.mealOrder = meal;
    let offerOrder = false;
    let offerRecipe = null;
    meal.recipes.forEach(
      (childrec) => {
        if (childrec.useReward) {
          this.getActiveReward.push(childrec.recipeId);
        }
        this.childReceipeData.id.push(childrec.recipeId);
        this.childReceipeData.childrec.push(childrec);
        if (childrec.offerId && this.getOfferRecipes) {
          this.getOfferRecipes.push(childrec.recipeId);
          offerRecipe = childrec;
          offerOrder = true;
        }
      }
    );
    if (this.getActiveReward && this.getActiveReward.length > 0) {
      this.getRewardInfo(meal.locationId);
    } else if (offerOrder) {
      if (offerRecipe != null) {
        this.getOfferInfo(offerRecipe);
      }
    } else {
      this.getDefaultMenuChildRecipeToCustomize(meal.locationId);
    }
    // call web api to get the order based on ID
    // set activeOrder in redux from the returned order
    // this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: data });
  }
  getRewardInfo(locationId) {
    this.rewards.getRewardSummary().then(
      (success) => {

        const response = <MessageSummaryLoyalty>success;

        // Scenario to handle if service doesn't return current rewards and visits count
        if (response) {
          this.currentRewardsCount = (response.currentRewards !== undefined) ? response.currentRewards : 0;
        }
        this.getDefaultMenuChildRecipeToCustomize(locationId);

      });

  }
  getOfferInfo(childrec: any) {
    this.proxy.httpGet(ApiRoutes.GET_OFFERS).toPromise().then(
      (success) => {
        if (success.body.valueOf()) {
          const userOfferList = <Offer[]>success.body;
          if (this.checkOfferPresent(childrec.offerId, userOfferList)) {
            this.offerService.setOfferList(userOfferList);
          }
        }
        this.getDefaultMenuChildRecipeToCustomize(this.mealOrder.locationId);
      });
  }
  getCurrentOffer(childRec: ChildRecipeEntity): Observable<Offer> {
    return this.proxy.httpGet(ApiRoutes.GET_OFFERS).pipe(
      map((response) => {
        const userOfferList = response.body as Offer[];
        return userOfferList.find(offer => offer.id === childRec.offerId);
      })
    );
  }

  checkOfferPresent(offerId: any, userOfferList: Offer[]): boolean {
    let isOfferPresent = false;
    if (offerId && userOfferList) {
      userOfferList.forEach(offer => {
        if (offer.id === offerId) {
          this.offerService.setSelectedOffer(offer);
          this.offerCouponCode = offer.id;
          isOfferPresent = true;
          return isOfferPresent;
        }
      });
    }
    return isOfferPresent;
  }


  redirectTo(uri: string) {
    this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri], { queryParams:
         UtilitiesService.generateQueryParams([Constants.SHOW_CART], ['true'])}));
  }

  getNonAvailabilityRecipe() {
    this.recipeIds = '';
    this.unavailableRecipes.forEach(recipe => {
      this.recipeIds += recipe.recipeId + ',';
    });
    if (this.recipeIds) {
      this.proxy.httpGet('/menu/recipes?recipeIds=' + this.recipeIds).subscribe(
        (success) => {
          if (!this.orderdCollection.childRecipes) {
            this.orderdCollection.childRecipes = [];
          }
          const Recipes = <Store.ChildRecipeEntity[]>success.body.valueOf();
          Recipes.forEach(recipe => {
            if (recipe.orderItemId === undefined) {
              const uid = Math.floor((Math.random() * 10000000000) + 1);
              recipe.orderItemId = Number(uid);
            }
            recipe.id = recipe.recipeId;
            recipe.isRecipeNotAvailable = true;
            this.orderdCollection.childRecipes.push(recipe);
            if(!recipe.isRecipeNotAvailable) {
              const gtmRecipePayload = this.gtmService.getGTMCartPayloadFromRecipe(recipe);
              this.gtmService.sendGenericEvent({ecommerce:null} as gtmExternal.CartGTM);
              this.gtmService.sendGenericEvent(gtmRecipePayload);
            }
          });
          this.orderdCollection.isFavorite = this.isFavorite;
          this.orderdCollection.favoriteName = this.favName;
          this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
        }
      );

    }
  }

  updateOrderCollection(ChildRecipeData, chdata) {
    // this.getRewardCount();
    // const rewardCount = Number(sessionStorage.getItem('rewardCount'));
    this.orderdCollection.isFavorite = this.isFavorite;
    this.orderdCollection.favoriteName = this.favName;
    const uid = Math.floor((Math.random() * 10000000000) + 1);
    ChildRecipeData.orderItemId = Number(uid);
    if (this.getActiveReward && this.getActiveReward[0] === chdata.recipeId && this.getActiveReward.length === 1 &&
      (!this.orderdCollection.childRecipes || !this.orderdCollection.childRecipes.find(child => child.useReward === true))
       && this.currentRewardsCount > 0) {
      ChildRecipeData.useReward = true;
      ChildRecipeData.totalPrice = 0;
      this.orderdCollection.isRewardAdded = true;
    }
    if (!this.orderdCollection.childRecipes) {
      this.orderdCollection.childRecipes = new Array<Store.ChildRecipeEntity>();
    }
    if (ChildRecipeData) {
      ChildRecipeData.customName = (chdata.customName !== undefined ? chdata.customName : null);
      this.orderdCollection.childRecipes.push(ChildRecipeData);
      const gtmRecipePayload = this.gtmService.getGTMCartPayloadFromRecipe(ChildRecipeData);
      this.gtmService.sendGenericEvent({ecommerce:null} as gtmExternal.CartGTM);
      this.gtmService.sendGenericEvent(gtmRecipePayload);
    }
  }

  // This function is to get the default recipe structure and
  // check for availability of recipe and modifers for selected location
  async getDefaultMenuChildRecipeToCustomize(locationId: number, isPresetCustomized: Boolean = false) {
    const recipeMap: RecipeMap[] = this.childReceipeData?.childrec?.map(r => ({recipeType: r.recipeTypeId, linkedRecipeId: r.customizations?.find(c=> c.linkedRecipeId)?.linkedRecipeId, recipeId: r.recipeId}));
    const distinctRecipeTypes = recipeMap.map(r=> r.recipeType).filter((elem, index, self) => index === self.indexOf(elem));
    const isMultipleLinkedRecipeTypes = distinctRecipeTypes?.length > 1;
    const linkedRecipeIds =  _.flatMap((this.childReceipeData?.childrec as Store.Recipe[])?.map(r => r?.customizations))?.filter(c=> (c as any).linkedRecipeId as number).map(c=> ((c as any).linkedRecipeId as number));
    if(linkedRecipeIds?.length) {
      this.childReceipeData.id = _.union(linkedRecipeIds, this.childReceipeData.id);
    } 
    let apiEndpoint = `${ApiRoutes.LOCATIONS}/${ this?.location?.isAssumedLocation ? locationId?.toString() ?? this.location.id : this.location.id}/menu/child-recipes?Ids=${this.childReceipeData.id}`;;
    const recipeType = (this.childReceipeData?.childrec as Store.Recipe[])[0]?.recipeTypeId;
    apiEndpoint += `&recipetypeid=${recipeType ?? RecipeType.MediumMeal}`;
    let singleItemCustomization: Boolean = false; // Check if only one quantity of one recipe is being sent as a preset customization
    let isRedirectForPresetCustomization: Boolean = false; // redirect to customization screen required?
    if (isPresetCustomized && this.childReceipeData && this.childReceipeData.childrec
      && this.childReceipeData.childrec.length === 1 &&
      this.childReceipeData.childrec[0].quantity &&
      this.childReceipeData.childrec[0].quantity === 1) {
      // Only one item in the customization - still to determine if redirect to customization is required
      singleItemCustomization = true;
    }
    if(isMultipleLinkedRecipeTypes) {
      const apiEndPoints = [];
      const recipeTypeGroup = _.groupBy(recipeMap, 'recipeType');
      Object.keys(recipeTypeGroup).forEach(g => apiEndPoints.push(`${ApiRoutes.LOCATIONS}/${(this?.location?.id ?? locationId?.toString())}/menu/child-recipes?Ids=${recipeTypeGroup[g].map(g => g.linkedRecipeId).join(',')},${recipeTypeGroup[g].map(g => g.recipeId).join(',')}&recipetypeId=${g}`));
      if(apiEndPoints.length) {
        const httpRequests = [];
        apiEndPoints.forEach(api => {
          httpRequests.push(this.proxy.httpGet(api));
        });
        let successResponse: Store.MultiChildRecipeResponse= {} ;
        successResponse.recipes = [];
        successResponse.ingredients = [];
        return this.subscriptions.add(combineLatest(httpRequests).subscribe(async (responses) => {
          responses.forEach(resp => {          
            const response = <Store.MultiChildRecipeResponse>(resp as any).body.valueOf(); 
            if(response?.recipes?.length) {
              successResponse.recipes.push(...response.recipes);
            } 
            if(response?.ingredients?.length) {
              successResponse.ingredients.push(...response.ingredients);
            }
          });
          this.processMultiChildResponse(successResponse, isPresetCustomized, singleItemCustomization, isRedirectForPresetCustomization);
        }));
      }            
    } else {
      return this.subscriptions.add(
        this.proxy.httpGet(apiEndpoint).subscribe(
          (success) => {
            const successResponse = <Store.MultiChildRecipeResponse>success.body.valueOf();
            this.processMultiChildResponse(successResponse, isPresetCustomized, singleItemCustomization, isRedirectForPresetCustomization);
          },
          error => {
            this.logger.logError(error);
          }
        )
      );
    }
  }
  private processMultiChildResponse(successResponse: Store.MultiChildRecipeResponse, isPresetCustomized: Boolean, singleItemCustomization: Boolean, isRedirectForPresetCustomization: Boolean) {
    if (successResponse !== undefined && successResponse.recipes !== undefined) {
      const selectItems = sessionStorage.getItem('select_items_gtm');
      if(selectItems) {
        sessionStorage.removeItem('select_items_gtm');
        const selectItemsGTMPayload = this.gtmService.getGTMEventPayloadFromRecipes(successResponse.recipes, 'select_item', selectItems);
        this.gtmService.sendGenericEvent({ ecommerce: null });
        this.gtmService.sendGenericEvent(selectItemsGTMPayload);
      }
      this.unavailableRecipes = [];
      const recipeArray = [];
      this.childReceipeData.childrec.forEach(chdata => {
        let isOfferAttached = false;
        let childRecipeData = new Store.ChildRecipeEntity();
        const modifierGroups = [];
        this.unavailableModifierGroups = [];
        this.nonExistentSpecialInstructions = [];
        this.nonExistentModifiers = [];
        const successResponseRecipes = JSON.stringify(successResponse.recipes);
        const childobj = JSON.parse(successResponseRecipes);
        // TODO: Loop and get the recipe to be dynamic to support multiple offer items
        if (this.getOfferRecipes && this.getOfferRecipes[0] === chdata.recipeId && chdata.offerId
          && this.offerService.getSelectedOffer(false)) {
          this.customizationService.paramSource = 'offer';
          this.customizationService.paramSplOpt = null;
          this.customizationService.setOffer(true);
          isOfferAttached = true;
          this.offerService.isBuyOneGetOneFree(this.offerService.getSelectedOffer(true), null, null);
        } else if (this.getOfferRecipes && this.getOfferRecipes.length > 0
          && this.offerService.getSelectedOffer(false)) {
          this.offerService.isBuyOneGetOneFree(this.offerService.getSelectedOffer(true), null, null);
        }
        if (!this.offerService.isBuyOneGetOne && !chdata.offerId &&
          this.customizationService.paramSource === 'offer') {
          // if the current recipe's iteration is not offer, why set paramSource to offer
          this.customizationService.paramSource = '';
        }
        const getIndex = childobj.findIndex(getID => getID.id === chdata.recipeId);
        childRecipeData = childobj.find(q => q.id === chdata.recipeId);
        // see if we have a linked recipe
        const customizedLinkRecipe = chdata?.customizations?.find(c => c.linkedRecipeId);
        if (customizedLinkRecipe && getIndex !== -1) {
          let linkedRecipe = childobj.find(c => c.id == customizedLinkRecipe?.linkedRecipeId);
          if (linkedRecipe) {
            // copy customizations to linkedRecipe
            linkedRecipe = this.updateLinkedRecipeChildCustomizations(linkedRecipe, customizedLinkRecipe);
            linkedRecipe.selectedScreen = 1;
            childRecipeData.context = Store.RecipeContext.CHILD;
            childRecipeData.linkedRecipe = linkedRecipe;
            const outerChildLinkedRecipeModifierGroup = childRecipeData?.customizationGroups
                                                          ?.find(cg => cg.modifierGroups?.find(mg => mg.linkedRecipeId && mg?.modifiers?.some(m => m.selectedChildRecipeId)))
                                                          ?.modifierGroups?.find(mg => mg.linkedRecipeId && mg.id== customizedLinkRecipe.modifierGroupId);
              if(outerChildLinkedRecipeModifierGroup?.linkedRecipeId && outerChildLinkedRecipeModifierGroup.linkedRecipeId != customizedLinkRecipe.linkedRecipeId) {
                outerChildLinkedRecipeModifierGroup.linkedRecipeId = customizedLinkRecipe.linkedRecipeId;
              }
          } else {
            recipeArray.push(customizedLinkRecipe?.linkedRecipeId);
            this.unavailableRecipes.push({
              recipeId: customizedLinkRecipe?.linkedRecipeId,
            });
          }
        }
        if (getIndex !== -1) { // if recipe is available for that selected location
          if (isOfferAttached && chdata.offerId) {
            childRecipeData.isOfferAdded = true;
            childRecipeData.offerCouponCode = this.offerCouponCode;
            if (this.offerService.isBuyOneGetOne) {
              childRecipeData.isAttachToOffer = true;
            }
          } else if (this.getOfferRecipes && this.getOfferRecipes.length > 0 &&
            this.offerService.isBuyOneGetOne && this.offerService.verifyOfferEligibleForTheChildRecipe(childRecipeData)) {
            if (this.orderdCollection.childRecipes) {
              const checkParent = this.orderdCollection.childRecipes.filter(el => {
                return el.isOfferAdded && !el.offerCouponCode;
              });
              if (checkParent && checkParent.length === 0) {
                childRecipeData.isOfferAdded = true;
              }
            } else {
              childRecipeData.isOfferAdded = true;
            }
          }
          chdata.customizations.forEach(cus => {
            childRecipeData.customizationGroups.forEach(custGroup => {
              custGroup.modifierGroups.forEach(modiGroup => {
                const modfierGroupId = childRecipeData.customizationGroups.
                  find(cusGroup => cusGroup.id === cus.customizationGroupId).modifierGroups.
                  find(modgroup => modgroup.id === cus.modifierGroupId);
                if (modfierGroupId) {
                  if (cus.modifierGroupId === modiGroup.id && cus.customizationGroupId === custGroup.id) {
                    modiGroup.isSelected = true;
                    modiGroup.modifiers.forEach(modifier => {
                      if (modiGroup.displayText.includes('Bread')) {
                        if (cus.modifierGroupId === modiGroup.id && cus.specialInstructionIds) {
                          modiGroup.specialInstructionId = cus.specialInstructionIds;

                          if (cus.modifierId === modifier.id) {
                            if (cus.specialInstructionIds.length > 0) {
                              cus.specialInstructionIds.forEach(spId => {
                                if (modifier?.specialInstructions?.length > 0) {
                                  modifier.specialInstructions.forEach(msp => {
                                    if (spId === msp.id) {
                                      msp.isEnabled = true;
                                    }
                                  });
                                }
                                const nonExistentSpecialInstructions: number[] = cus.specialInstructionIds.filter(i => !modifier?.specialInstructions?.map(si => si.id).includes(i));
                                if (nonExistentSpecialInstructions?.length) {
                                  // Missing special instructions under modifiers
                                  nonExistentSpecialInstructions.forEach(element => {
                                    if (!this.nonExistentSpecialInstructions?.find(n => n.specialInstructionId == element && n.modifierId == modifier.id)) {
                                      this.nonExistentSpecialInstructions.push({ recipeId: chdata.recipeId, orderItemId: chdata.orderItemId, customizationGroupId: cus.customizationGroupId, modifierGroupId: modiGroup.id, modifierId: modifier.id, specialInstructionId: element, name: '' });
                                    }
                                  });
                                }
                              });
                            }
                          }
                        }
                      }
                      if (cus.modifierId === modifier.id) {
                        modiGroup.selectedModifier = modifier.id;
                        modifier.isSelected = true;
                        this.subTotal += modifier.price ? modifier.price : 0;
                      }
                    });
                    if (!modiGroup.modifiers.some(m => m.id == cus.modifierId)) {
                      // got missing modifiers
                      this.nonExistentModifiers.push({ orderItemId: childRecipeData.orderItemId, recipeId: chdata.recipeId, customizationGroupId: cus.customizationGroupId, modifierGroupId: cus.modifierGroupId, modifierId: cus.modifierId, name: '' });
                    }
                  }
                } else { // if modifer groups are not available
                  if (!modifierGroups.find(d => d === cus.modifierGroupId)) {
                    modifierGroups.push(cus.modifierGroupId);
                    this.unavailableModifierGroups.push({
                      orderItemId: childRecipeData.orderItemId,
                      modifierGroupId: cus.modifierGroupId,
                      recipeId: chdata.recipeId,
                      modifierId: cus.modifierId
                    });
                  }
                }
              });
            });
            childRecipeData.quantity = chdata.quantity;
            childRecipeData.ingredientsList = successResponse.ingredients;
            childRecipeData = this.menuUtil.updateRecipeIncludedInfo(childRecipeData);
            childRecipeData = this.customizationService.myOrderSummaryCalAndPrice(childRecipeData);
          });
        } else { // if recipe is not available for that selected location
          // if (recipeArray.find(d => d === chdata.recipeId)) {
          recipeArray.push(chdata.recipeId);
          this.unavailableRecipes.push({
            recipeId: chdata.recipeId,
          });
          // }
        }
        if (childRecipeData) { // if recipe is available
          if (this.nonExistentModifiers?.length) {
            // Check modifiers names and update childRecipeData
            childRecipeData.nonExistentModifiers = this.nonExistentModifiers;
          }
          if (this.nonExistentSpecialInstructions?.length) {
            childRecipeData.nonExistentSpecialInstructions = this.nonExistentSpecialInstructions;
          }
          const areModifiersUnavailable = this.unavailableModifierGroups.find(d => d.recipeId === chdata.recipeId);
          if (areModifiersUnavailable) {
            childRecipeData.isDrinksNotAvailable = true;
            this.modifierGroupIds = '';
            this.unavailableModifierGroups.forEach(modifierGroup => {
              this.modifierGroupIds += modifierGroup.modifierGroupId + ',';
            });
            if (this.modifierGroupIds) {
              // if modifer groups are not available make a service call and get the modifier group name to display with error message
              return this.proxy.httpGet(`${ApiRoutes.MODIFIER_GROUP_LOOKUP}?ids=` + this.modifierGroupIds).subscribe(
                (modifierGroupSuccess) => {
                  const modifierGroupLookupResponse = <Store.ModifierGroupResponse>modifierGroupSuccess.body.valueOf();
                  childRecipeData.UnavailableModifierGroups = '';
                  childRecipeData.nonExistentModifierGroups = [];
                  modifierGroupLookupResponse.modifierGroups.forEach(modGroup => {
                    if (modGroup.isPublished) {
                      childRecipeData.UnavailableModifierGroups += modGroup.name + ', ';
                    } else {
                      childRecipeData.nonExistentModifierGroups.push({ orderItemId: childRecipeData.orderItemId, recipeId: chdata.recipeId, modifierGroupId: modGroup.id, name: modGroup.name, modifierId: this.unavailableModifierGroups.find(u => u.modifierGroupId == modGroup.id)?.modifierId });
                    }
                    const modifierGroupObj = chdata.customizations.find(cust => cust.modifierGroupId === modGroup.id);
                    const customizationGroupObj = childRecipeData.customizationGroups.
                      find(cusGroup => cusGroup.id === modifierGroupObj.customizationGroupId);
                    if (customizationGroupObj.screenNumber === 2) {
                      childRecipeData.mealIncludes += ', ' + modGroup.name;
                    } else {
                      childRecipeData.whatsOnIt += ', ' + modGroup.name;
                    }
                  });
                  if (isPresetCustomized && singleItemCustomization
                    && childRecipeData.recipeTypeId === 1
                    && childRecipeData.customizationGroups.some(cg => cg.screenNumber === 2)
                    && childRecipeData.UnavailableModifierGroups.length <= 0
                    && this.unavailableRecipes.length <= 0) {
                    // A la carte item
                    this.logger.log('Navigating to customization 1 - a la carte');
                    sessionStorage.setItem('childRecipe', JSON.stringify(childRecipeData));
                    isRedirectForPresetCustomization = true;
                    this.router.navigateByUrl(this.buildCustomizationRedirectUrl(childRecipeData));

                  } else if (isPresetCustomized && singleItemCustomization
                    && childRecipeData.recipeTypeId > 1 &&
                    childRecipeData.UnavailableModifierGroups.length <= 0 &&
                    this.unavailableRecipes.length <= 0) {
                    // Meal item
                    this.logger.log('Navigating to customization 1 - meal');
                    this.unSelectDrink(childRecipeData); // Unselect drink on customization 2 if the order is a meal
                    sessionStorage.setItem('childRecipe', JSON.stringify(childRecipeData));
                    isRedirectForPresetCustomization = true;
                    this.router.navigateByUrl(this.buildCustomizationRedirectUrl(childRecipeData));
                  } else {
                    this.updateOrderCollection(childRecipeData, chdata);
                    if (childRecipeData.nonExistentModifierGroups) {
                      this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
                    }
                  }
                }
              );
            }
          } else {
            if (isPresetCustomized && singleItemCustomization
              && childRecipeData.recipeTypeId === 1
              && childRecipeData.customizationGroups.some(cg => cg.screenNumber === 2)
              && this.unavailableRecipes.length <= 0) {
              // Redirect to customization 1
              this.logger.log('Navigating to customization 1 - a la carte 2');
              sessionStorage.setItem('childRecipe', JSON.stringify(childRecipeData));
              isRedirectForPresetCustomization = true;
              this.router.navigateByUrl(this.buildCustomizationRedirectUrl(childRecipeData));
            } else if (isPresetCustomized && singleItemCustomization &&
              childRecipeData.recipeTypeId > 1
              && this.unavailableRecipes.length <= 0) {
              // Redirect to customization 1
              this.logger.log('Navigating to customization 1 - meal 2');
              this.unSelectDrink(childRecipeData);
              sessionStorage.setItem('childRecipe', JSON.stringify(childRecipeData));
              isRedirectForPresetCustomization = true;
              this.router.navigateByUrl(this.buildCustomizationRedirectUrl(childRecipeData));
            } else {
              this.updateOrderCollection(childRecipeData, chdata);
            }
          }

        }
      });
      if (this.unavailableRecipes.length > 0) {
        // if recipe is not available make a service call and get the default structure of recipe to show with error message
        this.getNonAvailabilityRecipe();
      } else {
        this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
      }
    }
    if (!isRedirectForPresetCustomization) {
      this.redirectTo('/menu');
    }
    return isRedirectForPresetCustomization;
  }
  public updateLinkedRecipeChildCustomizations(linkedRecipe: ChildRecipeEntity, customizedLinkRecipe): ChildRecipeEntity {
    linkedRecipe.context = Store.RecipeContext.LINKED;
    customizedLinkRecipe?.childCustomizations?.forEach(cus => {
      linkedRecipe.customizationGroups.forEach(custGroup => {
        custGroup.modifierGroups.forEach(modiGroup => {
          const modfierGroupId = linkedRecipe.customizationGroups.
            find(cusGroup => cusGroup.id === cus.customizationGroupId).modifierGroups.
            find(modgroup => modgroup.id === cus.modifierGroupId);
          if (modfierGroupId) {
            if (cus.modifierGroupId === modiGroup.id && cus.customizationGroupId === custGroup.id) {
              modiGroup.isSelected = true;
              modiGroup.modifiers.forEach(modifier => {
                if (modiGroup.displayText.includes('Bread')) {
                  if (cus.modifierGroupId === modiGroup.id && cus.specialInstructionIds) {
                    modiGroup.specialInstructionId = cus.specialInstructionIds;

                    if (cus.modifierId === modifier.id) {
                      if (cus.specialInstructionIds.length > 0) {
                        cus.specialInstructionIds.forEach(spId => {
                          if (modifier?.specialInstructions?.length > 0) {
                            modifier.specialInstructions.forEach(msp => {
                              if (spId === msp.id) {
                                msp.isEnabled = true;
                              }
                            });
                          }
                          const nonExistentSpecialInstructions: number[] = cus.specialInstructionIds.filter(i => !modifier?.specialInstructions?.map(si => si.id).includes(i));
                          if (nonExistentSpecialInstructions?.length) {
                            // Missing special instructions under modifiers
                            nonExistentSpecialInstructions.forEach(element => {
                              if(!this.nonExistentSpecialInstructions?.find(n => n.specialInstructionId == element && n.modifierId == modifier.id)){
                                this.nonExistentSpecialInstructions.push({recipeId: customizedLinkRecipe.linkedRecipeId, orderItemId: customizedLinkRecipe?.orderItemId, customizationGroupId: cus.customizationGroupId, modifierGroupId: modiGroup.id, modifierId: modifier.id, specialInstructionId: element, name: ''});
                              }
                            });
                          }
                        });
                      }
                    }
                  }
                }
                if (cus.modifierId === modifier.id) {
                  modiGroup.selectedModifier = modifier.id;
                  modifier.isSelected = true;
                  this.subTotal += modifier.price ? modifier.price : 0;
                }
              });
              if(!modiGroup.modifiers.some(m => m.id == cus.modifierId)) {
                // got missing modifiers
                this.nonExistentModifiers.push({orderItemId: linkedRecipe.orderItemId, recipeId: customizedLinkRecipe.linkedRecipeId, customizationGroupId: cus.customizationGroupId, modifierGroupId: cus.modifierGroupId, modifierId: cus.modifierId, name: '' });
              }
            }
          } else { // if modifer groups are not available           
              this.unavailableModifierGroups.push({
                orderItemId: linkedRecipe?.orderItemId,
                modifierGroupId: cus.modifierGroupId,
                recipeId: customizedLinkRecipe.linkedRecipeId,
                modifierId: cus.modifierId
              });
            // }
          }
        });
      });
      linkedRecipe.customizationGroups.forEach(cg =>
        cg.modifierGroups.forEach(mg => {
          if (mg.isSelected == null && isModifierGroupDefaultSelected(mg, cg) && !customizedLinkRecipe.childCustomizations.map(cc => cc.modifierGroupId).some(mgid => mgid == mg.id)) {
            mg.isSelected = false;
          }
        }));
      linkedRecipe.quantity = customizedLinkRecipe.quantity;
      linkedRecipe = this.menuUtil.updateRecipeIncludedInfo(linkedRecipe);
      linkedRecipe = this.customizationService.myOrderSummaryCalAndPrice(linkedRecipe);
    });
    
    return linkedRecipe;
  }
  async getUserOrderInfo(isLoggedIn: boolean,
    orderIdByparam?: number) {
    const ordernumber = this.order && this.order.orderNumber ? this.order.orderNumber : orderIdByparam;
    const apiRoute = isLoggedIn ? ApiRoutes.GET_ORDER_BY_ID + ordernumber
      : '/meals/orders/' + this.order.orderNumber + '/guestuser/' + this.order.guid;
    await this.proxy.httpGet(apiRoute).toPromise().then(async resp => {
      const success = <any>resp.body;
      if (success) {
      this.orderDetails = <OrderDetails>success;
      let childRecipeIds = '';
      this.location = <LocationsEntity>success.location;
      (this.orderDetails as any).recipes.forEach(childRecipe => {
        childRecipeIds += childRecipe.recipeId + ',';
      });

      await this.getChildRecipes(childRecipeIds);
    }
    });

  }

  private async getChildRecipes(childRecipeIds: any) {
    this.initializeTotalAndTax();
    const apiEndpoint = ApiRoutes.LOCATIONS + '/' + this.location.id +
      ApiRoutes.CHILD_RECIPE + '/?Ids=' + childRecipeIds;
    const childRecipesCustomization: Store.ChildRecipeEntity[] = [];

    await this.proxy.httpGet(apiEndpoint).toPromise().then(response => {
      const result = <any>response.body;
      if (result) {
        const childRecipes = <ChildRecipeEntity[]>result.recipes;
        const selectItems = sessionStorage.getItem('select_items_gtm');
        if(selectItems) {
          sessionStorage.removeItem('select_items_gtm');
          const selectItemsGTMPayload = this.gtmService.getGTMEventPayloadFromRecipes(childRecipes, 'select_item', selectItems);
          this.gtmService.sendGenericEvent({ ecommerce: null });
          this.gtmService.sendGenericEvent(selectItemsGTMPayload);
        }
        const ingredientsRecipe = <IngredientsEntity[]>result.ingredients;
        childRecipes.forEach(childRecipe => {
          childRecipesCustomization.push(childRecipe);
        });
        this.getChildCustomizations(ingredientsRecipe, childRecipesCustomization);
      }
    });
  }
  private getChildCustomizations(ingredientsRecipe: IngredientsEntity[],
    childRecipesCustomization: Store.ChildRecipeEntity[]) {
    (this.orderDetails as any).recipes.forEach(childRecipe => {
      childRecipe.whatsOnIt = '';
      childRecipe.comesWith = '';
      childRecipe.totalPrice = 0;
      childRecipe.totalCalories = 0;
      const recipe = <ChildRecipeEntity[]>childRecipesCustomization.filter(
        obj => obj.id === childRecipe.recipeId);

      this.ingredientList = []; // Reset the ingredientList
      recipe.forEach(obj => {
        childRecipe.name = obj.name;
        childRecipe.subTitle = obj.subTitle;
        childRecipe.totalPrice += obj.recipeBasicInfo.price;

        // Handling Total price for Reward Item and offers
        if (childRecipe.useReward === true) {
          childRecipe.totalPrice = 0;
        } else if (childRecipe.offerId) {
          this.getCurrentOffer(childRecipe).subscribe(offer => {
            childRecipe.totalPrice = this.offerService.calculateOfferPriceForRecipe(offer, childRecipe);
            childRecipe.totalCalories = 0;
            childRecipe.whatsOnIt = '';
            childRecipe.comesWith = '';
            this.subTotal += childRecipe.totalPrice * childRecipe.quantity;
            this.ingredientList = [];
            this.calculateChildRecipePricingAndCalories(obj, childRecipe, ingredientsRecipe);
            this.calculateTotal();
          });
        }
        // Subgroup
        this.calculateChildRecipePricingAndCalories(obj, childRecipe, ingredientsRecipe);
      });
      this.subTotal += childRecipe.totalPrice * childRecipe.quantity;
      childRecipe.whatsOnIt = childRecipe.whatsOnIt.slice(0, -2);
      childRecipe.comesWith = childRecipe.comesWith.slice(0, -2);
      this.calculateTotal();
    });
  }
  private calculateChildRecipePricingAndCalories(obj: ChildRecipeEntity, childRecipe: any, ingredientsRecipe: IngredientsEntity[]) {
    obj.customizationGroups.forEach(cg => {
      this.customizationSubgroupService.setSelectedModifiers(cg, childRecipe.customizations);
    });

    obj.customizationGroups.forEach(cg => {
      if (cg && cg.customizationSubGroups && cg.customizationSubGroups.length > 0) {
        const selectedSubGroupEntity = this.customizationSubgroupService.calculateSubGroupPrice(cg);
        selectedSubGroupEntity.forEach(subGroup => {
          const modifiedCustSubPrice = (subGroup.subQuantity * subGroup.subPrice)
            + (subGroup.quantity * subGroup.modifierUnitPrice);
          childRecipe.totalPrice += modifiedCustSubPrice;
        });
      }
    });

    const ingredientsGroup = obj.ingredients;
    childRecipe.customizations.forEach(customization => {
      const customizationGroup = <CustomizationGroupsEntity[]>obj.customizationGroups.filter(
        cust => cust.id === customization.customizationGroupId);
      customizationGroup.forEach(group => {
        const modifierGroups = <Store.ModifierGroupsEntity[]>group.modifierGroups.filter(
          modifier => modifier.id === customization.modifierGroupId);
        modifierGroups.forEach(modifierGroup => {
          const modifierGroupText = modifierGroup.displayText;
          let customizationName = '';

          const modifiers = modifierGroup.modifiers.filter(modifier => modifier.id === customization.modifierId);
          modifiers.forEach(modifier => {
            if (!this.customizationSubgroupService.isModifierExistInSubgroup(group, modifierGroup)) {
              if (!group.canOverride) {
                childRecipe.totalPrice += modifier.price ? modifier.price : 0;
              } else {
                if (childRecipe.recipeTypeId === 1 && childRecipe.offerId) {
                  childRecipe.totalPrice += 0;
                } else {
                  if (!(childRecipe.useReward === true || childRecipe.offerId)) {
                    childRecipe.totalPrice += modifier.price ? modifier.price : 0;
                    // Checking for recipeTypeId to be A la carte
                    // TODO: We have to move this magic number 1 to an ENUM
                    if (childRecipe.recipeTypeId === 1) {
                      childRecipe.totalPrice -= obj.recipeBasicInfo.price;
                    }
                  }
                }
              }
            }
            modifier.ingredients.forEach(ingredient => {
              this.ingredientList.push(ingredient);
            });

            const specialInstructions = customization.specialInstructionIds ?
              (modifier.specialInstructions ? modifier.specialInstructions : [])
                .filter(sp => customization.specialInstructionIds.some(spids => spids === sp.id)) : '';
            if (specialInstructions && specialInstructions.length > 0) {
              const spcialNames = specialInstructions.map(sp => sp.displayText ? sp.displayText : sp.name);
              customizationName += ' (' + spcialNames.join(', ') + ')';
            }
          });
          const modifierText = modifierGroup.modifiers.filter(modifier => modifier.id === customization.modifierId)
            .map(mod => mod.displayText);
          if (modifierText) {
            if (group.screenNumber === 1) {
              if (modifierGroupText === 'Bread') {
                childRecipe.whatsOnIt = childRecipe.whatsOnIt
                  .concat(modifierText + customizationName + ', ');
              } else {
                childRecipe.whatsOnIt = childRecipe.whatsOnIt
                  .concat(modifierGroupText + ' (' + modifierText + '), ');
              }
            } else if (group.screenNumber === 2) {
              childRecipe.comesWith = childRecipe.comesWith
                .concat(modifierGroupText + ' (' + modifierText + '), ');
            }
          }
        });
      });
    });
    this.calculateCalories(ingredientsRecipe, childRecipe, ingredientsGroup);
    if (obj.ingredients !== null) {
      obj.ingredients.forEach(foodItem => {
        if (foodItem.isProminent) {
          const ingredientDetails = ingredientsRecipe.find(ingredient => ingredient.id === foodItem.ingredientId);
          if (ingredientDetails !== null) {
            childRecipe.whatsOnIt += ingredientDetails.name;
          }
        }
      });
    }
  }

  private calculateCalories(ingredients: IngredientsEntity[], recipe: Store.MealRecipe, ingredientsGroup: Store.IngredientMultiplier[]) {
    this.ingredientList.forEach(ingredient => {
      const list = ingredients.find(obj => obj.id === ingredient.ingredientId);
      if (list && list.nutritionInfo && list.nutritionInfo.calories) {
        const cal =
          list.nutritionInfo.calories *
          (ingredient.multiplier ? ingredient.multiplier : 1);
        recipe.totalCalories += this.menuUtil.RoundCalories(cal);
      }
    });

    if (ingredientsGroup.length > 0) {
      ingredientsGroup.forEach(ingredient => {
        const ingredientItem = ingredients.find(obj => obj.id === ingredient.ingredientId);
        if (ingredientItem && ingredientItem.nutritionInfo && ingredientItem.nutritionInfo.calories) {
          recipe.totalCalories += this.menuUtil.RoundCalories(ingredientItem.nutritionInfo.calories *
            (ingredient.multiplier ? ingredient.multiplier : 1));
        }
      });
    }

    recipe.totalCalories = Math.round(recipe.totalCalories);
  }
  private calculateTotal() {
    const taxRate = this.taxCalulcator.calculateTaxRate(this.location);
    this.tax = this.taxCalulcator.CalculateTax(this.subTotal, taxRate.taxRate, taxRate.taxRoundingType);
    this.isTaxIncluded = this.taxCalulcator.IsTaxIncluded(taxRate.taxRoundingType);
    this.orderTotal = this.subTotal + this.tax;
    this.order.orderTotal = this.orderTotal;
    this.ngRedux.dispatch({ type: Actions.SUBMITTEDORDER, data: this.order });
  }
  async getPresetCustomizedOrder(id: string, isLoggedIn: Boolean = false) {
    if (isLoggedIn) {
      this.rewards.getRewardSummary().then(
        (success) => {
          const response = <MessageSummaryLoyalty>success;
          // handle rewards and visits count.... TODO: check if is this really needed for preset customized orders?
          if (response) {
            this.currentRewardsCount = (response.currentRewards !== undefined) ? response.currentRewards : 0;
            this.subscriptions.add(this.activeOrder.subscribe(
              (Succ) => {
                if (Succ && Succ.childRecipes && Succ.childRecipes.length > 0) {
                  this.orderdCollection = _.cloneDeep(Succ as Store.Order);
                  if (!this.orderdCollection.childRecipes.find(child => child.isOfferAdded === true || !child.offerCouponCode)) {
                    if (!this.orderdCollection.childRecipes.find(child => child.useReward === true)) {
                      this.getActiveReward = [];
                      this.rewardItemService.updateCurrentRewardItem(undefined);
                    } else if (this.orderdCollection.childRecipes.find(child => child.useReward === true)) {
                      this.childRecipe = this.orderdCollection.childRecipes.find(child => child.useReward === true);
                      this.rewardItemService.updateCurrentRewardItem(this.childRecipe);
                    }
                  }
                } else {
                  this.orderdCollection.childRecipes = [];
                  this.getActiveReward = [];
                }
              },
              (Err) => {
                this.alertService.error(Err.error.message);
              }));
            this.getPresetCustomizedMeal(id);
          }
        },
        (err) => {
          this.alertService.error(err.error.message);
        });
    } else {
      this.getPresetCustomizedMeal(id);
    }
  }
  private getPresetCustomizedMeal(id: string) {
    this.proxy.httpGet(ApiRoutes.SHAREDFAVORITE + '/' + id).toPromise().then(
      (success1) => {
        const successResp = <Store.Meal>success1.body.valueOf();
        const meal = successResp;
        if (this.orderdCollection.childRecipes) {
          if (this.orderdCollection.childRecipes.length > 0) {
            this.isFavorite = false;
          }
        }


        this.childReceipeData = {};
        this.childReceipeData.childrec = [];
        this.childReceipeData.id = [];
        meal.recipes.forEach(
          (childrec) => {
            this.childReceipeData.id.push(childrec.recipeId);
            this.childReceipeData.childrec.push(childrec);
            if (this.orderdCollection && this.orderdCollection.childRecipes &&
              !this.orderdCollection.childRecipes.find(child => child.isOfferAdded === true || !child.offerCouponCode)) {
              if (childrec.useReward) {
                if (this.getActiveReward === undefined) {
                  this.getActiveReward = [];
                }
                this.getActiveReward.push(childrec.recipeId);
              }
            }
          }
        );
        this.getDefaultMenuChildRecipeToCustomize(meal.locationId, true);
      },
      (err) => {
        const errorMessage = ErrorCodesService.getErrorMessage(err.error.code, null);

        this.confirmModalService.show(
          '', // header
          '', // subHeader
          errorMessage, // message
          this.confirmText, // btn1Text
          '', // btn2Text
          '', // cancelText
          true, // hidePrevious: boolean
          this.confirmText, // btn1Emit
          '', // btn2Emit
          '', // cancelEmit
        );
      }
    );
  }
  private unSelectDrink(childRecipeData: ChildRecipeEntity) {
    if (childRecipeData.recipeTypeId && childRecipeData.recipeTypeId > 1) {
      childRecipeData.customizationGroups.find(r => r.type === 2 && r.screenNumber === 2).modifierGroups.forEach(mg => {
        mg.isSelected = false;
        mg.selectedModifier = null;
      });
    }
  }
  private buildCustomizationRedirectUrl(childRecipeData: ChildRecipeEntity): string {
    return '/locations/' +
      this.location.unit +
      '/menu/categories/' +
      childRecipeData.categoryId +
      '/recipes/' + childRecipeData.parentRecipeId +
      '/customization/1/presettype/' +
      childRecipeData.recipeTypeId;
  }

  public isAssumedLocation() {
    if (this.location) {
      return this.location.isAssumedLocation;
    }
    return false;
  }
  public setDeliveryAddressLoadStatus(status: boolean) {
    this.deliveryAddressloadedSubject.next(status);
  }
  private onlineOrderingNotAvailable() {
    this.confirmModalService.show(
      'Online ordering isn\'t available at this location right now.',
      '',
      '',
      'OK, Got It',
      '',
      '',
      true,
      'redirectToMenu',
      '',
      ''
    );
  }
}
